import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import "../Assets/Css/Invoice-filter.scss";
import Accordion from "react-bootstrap/Accordion";
import { customStyle } from "./Style";
import moment from "moment";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";
import { useNavigate } from "react-router-dom";
import { getClients } from "../Services/Clients/action";
import { getShareholdersList } from "../Services/Shareholders/action";
import { getCurrencyList } from "../Services/Invoices/action";

function Invoicefilter(props) {
  const navigate = useNavigate();

  const [selectFilters, setSelectedFilters] = useState({
    startDate: "",
    endDate: "",
    clients: [],
    status: [],
    shareHolders: [],
    currency: "",
    min: "",
    max: "",
    limit: 20,
    page: 1,
  });



  const [quickFilter, setQuickFilter] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [isTransaction, setIsTransaction] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);
  const [initialClientOptions, setInitialClientOptions] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);

  const currencyOptions = currencyData.map((curr) => ({
    value: curr.code,
    label: curr.code,
  }));
  const options = [...currencyOptions];

  useEffect(() => {
    if (!dataFetched) {
      const fetchInitialClients = async () => {
        try {
          const response = await props?.getClients("");
          console.log("client list ==>", response);

          const clientOptions = response?.data?.rows?.map((client) => ({
            label: client?.name,
            value: client?.id,
          }));

          setInitialClientOptions(clientOptions);
          setDataFetched(true);
        } catch (error) {
          console.error("Error ==>", error);
        }
      };

      fetchInitialClients();
    }
  }, [dataFetched, props?.clientList]);


  const loadClientOptions = (inputValue, callback) => {
    const filteredOptions = initialClientOptions?.filter((option) =>
      option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
    );
    callback(filteredOptions);
  };

  const shareHoldersOptions =
    props.shareHolders.length > 0
      ? props.shareHolders.map((shareHolder) => {
        return { label: shareHolder.name, value: shareHolder.name };
      })
      : [];

  const statusOptions = [
    { value: "Draft", label: "Draft" },
    { value: "Sent", label: "Sent" },
    { value: "Partially Paid", label: "Partially Paid" },
    { value: "Paid", label: "Paid" },
  ];

  const transactionStatusOptions = [
    { value: "Assigned", label: "Assigned" },
    { value: "Unassigned", label: "Unassigned" }
  ]

  const handleReset = (event) => {
    event.preventDefault();
    setSelectedFilters({
      startDate: "",
      endDate: "",
      clients: [],
      status: [],
      shareHolders: [],
      currency: "",
      min: "",
      max: "",
      limit: 20,
      page: 1,
    });
    setSelectedClients('');
    setQuickFilter("");

    let params = {
      startDate: "",
      endDate: "",
      clients: [],
      status: [],
      shareHolders: [],
      currency: "",
      min: "",
      max: "",
      limit: 20,
      page: 1,
    };
    const stringParams = queryString.stringify({ limit: params.limit, page: params.page });
    navigate(`?${stringParams}`);
  };
  useEffect(() => {
    if (props.shareHolders.length === 0) {
      props.getShareHoldersList();
    }
    fetchCurrencyData();
    const pathname = window.location.pathname;
    if (pathname.includes("/transaction")) {
      setIsTransaction(true);
    }
  }, []);

  useEffect(() => {
    setTheCurrencyData()
  }, [props?.currencylist])

  const fetchCurrencyData = async () => {
    try {
      await props.getCurrencyList();
      setTheCurrencyData();
    } catch (error) {
    }
  }

  const setTheCurrencyData = async () => {
    try {
      setCurrencyData(await props?.currencylist);
    } catch (error) {
      toast.error(error);
    }
  }

  useEffect(() => {
    let sDate = new Date(props?.filter?.startDate) || "";
    let eDate = new Date(props?.filter?.endDate) || "";

    if (sDate && eDate) {
      let diffTime = eDate.getTime() - sDate.getTime();
      let diffDay = diffTime / (1000 * 3600 * 24);
      if (diffDay === 7) {
        setQuickFilter("week");
      } else if (diffDay === 365) {
        setQuickFilter("year");
      } else if (diffDay === 30) {
        setQuickFilter("month");
      } else if (
        diffDay === 28 &&
        (sDate.getMonth() === 1 || eDate.getMonth() === 1)
      ) {
        setQuickFilter("month");
      }
    }

    let filters = {};

    props.filter.startDate
      ? (filters["startDate"] = new Date(
        moment(props.filter.startDate).format("YYYY-MM-DD")
      ))
      : (filters["startDate"] = selectFilters.startDate);

    props.filter.endDate
      ? (filters["endDate"] = new Date(
        moment(props.filter.endDate).format("YYYY-MM-DD")
      ))
      : (filters["endDate"] = selectFilters.endDate);

    if (props.filter.clients) {
      filters["clients"] = [];
      if (Array.isArray(props.filter.clients)) {
        props.filter.clients.map((client) => {
          return filters["clients"].push({ label: client, value: client });
        });
      } else if (typeof props.filter.clients === "string") {
        filters["clients"].push({
          label: props.filter.clients,
          value: props.filter.clients,
        });
      }
    } else {
      filters["clients"] = selectFilters.clients;
    }

    if (props.filter.status) {
      filters["status"] = [];
      if (Array.isArray(props.filter.status)) {
        props.filter.status.forEach((sta) => {
          let selectedStatus;
          {
            !isTransaction ? (selectedStatus = statusOptions.find(
              (option) => option.value === sta
            )) : (selectedStatus = transactionStatusOptions.find(
              (option) => option.value === sta
            ))
          }
          if (selectedStatus) {
            filters["status"].push(selectedStatus);
          }
        });
      } else if (typeof props.filter.status === "string") {
        let selectedStatus;
        {
          !isTransaction ? (selectedStatus = statusOptions.find(
            (option) => option.value === props.filter.status
          )) : (selectedStatus = transactionStatusOptions.find(
            (option) => option.value === props.filter.status
          ))
        }
        if (selectedStatus) {
          filters["status"].push(selectedStatus);
        }
      }
    } else {
      filters["status"] = selectFilters.status;
    }

    if (props.filter.shareHolders) {
      filters["shareHolders"] = [];
      if (Array.isArray(props.filter.shareHolders)) {
        props.filter.shareHolders.forEach((sh) => {
          const selectedShareHolder = shareHoldersOptions.find(
            (option) => option.value === sh
          );
          if (selectedShareHolder) {
            filters["shareHolders"].push(selectedShareHolder);
          }
        });
      } else if (typeof props.filter.shareHolders === "string") {
        const selectedShareHolder = shareHoldersOptions.find(
          (option) => option.value === props.filter.shareHolders
        );
        if (selectedShareHolder) {
          filters["shareHolders"].push(selectedShareHolder);
        }
      }
    } else {
      filters["shareHolders"] = selectFilters.shareHolders;
    }
    if (props.filter.currency) {
      filters["currency"] = options.find(
        (option) => option.value === props.filter.currency
      );
    } else {
      filters["currency"] = selectFilters.currency;
    }

    props.filter.min
      ? (filters["min"] = props.filter.min)
      : (filters["min"] = selectFilters.min);

    props.filter.max
      ? (filters["max"] = props.filter.max)
      : (filters["max"] = selectFilters.max);

    props.filter.limit
      ? (filters["limit"] = props.filter.limit)
      : (filters["limit"] = selectFilters.limit);
    props.filter.page
      ? (filters["page"] = props.filter.page)
      : (filters["page"] = selectFilters.page);

    setSelectedFilters({ ...filters });
  }, [props?.filter]);

  const handleApply = (event) => {
    event.preventDefault();
    let params = {};

    if (!params["startDate"] && selectFilters.startDate) {
      let date = selectFilters.startDate;
      params["startDate"] =
        date.getFullYear() +
        "-" +
        parseFloat(date.getMonth() + 1) +
        "-" +
        date.getDate();
    }
    if (!params["endDate"] && selectFilters.endDate) {
      let date = selectFilters.endDate;
      params["endDate"] =
        date.getFullYear() +
        "-" +
        parseFloat(date.getMonth() + 1) +
        "-" +
        date.getDate();
    }
    if (!params["clients"] && selectFilters.clients.length > 0) {
      params["clients"] = [];
      selectFilters.clients.map((client) => {
        return params["clients"].push(client.value);
      });
    }
    if (!params["status"] && selectFilters.status.length > 0) {
      params["status"] = [];
      selectFilters.status.map((status) => {
        return params["status"].push(status.value);
      });
    }
    if (!params["shareHolders"] && selectFilters.shareHolders.length > 0) {
      params["shareHolders"] = [];
      selectFilters.shareHolders.map((sh) => {
        return params["shareHolders"].push(sh.value);
      });
    }
    if (!params["currency"] && selectFilters?.currency) {

      params["currency"] = selectFilters?.currency.value;
    }
    if (!params["min"] && selectFilters.min) {
      params["min"] = selectFilters.min;
    }
    if (!params["max"] && selectFilters.max) {
      params["max"] = selectFilters.max;
    }
    if (!params["limit"] && selectFilters.limit) {
      params["limit"] = selectFilters.limit;
    }
    if (!params["page"] && selectFilters.page) {
      params["page"] = selectFilters.page;
    }
    const stringParams = queryString.stringify(params);

    navigate(`?${stringParams}`);
  };



  useEffect(() => {
    if (quickFilter === "week") {
      setSelectedFilters({
        ...selectFilters,
        startDate: new Date(moment().subtract(1, "weeks").format("YYYY-MM-DD")),
        endDate: new Date(moment().format("YYYY-MM-DD")),
      });
    } else if (quickFilter === "month") {
      setSelectedFilters({
        ...selectFilters,
        startDate: new Date(
          moment().subtract(1, "months").format("YYYY-MM-DD")
        ),
        endDate: new Date(moment().format("YYYY-MM-DD")),
      });
    } else if (quickFilter === "year") {
      setSelectedFilters({
        ...selectFilters,
        startDate: new Date(moment().subtract(1, "years").format("YYYY-MM-DD")),
        endDate: new Date(moment().format("YYYY-MM-DD")),
      });
    }
  }, [quickFilter]);

  useEffect(() => {
    if (
      selectFilters["startDate"] !== "" ||
      selectFilters["endDate"] !== "" ||
      selectFilters["clients"].length > 0 ||
      selectFilters["status"].length > 0 ||
      selectFilters["shareHolders"].length > 0 ||
      selectFilters["currency"] !== "" ||
      selectFilters["min"] !== "" ||
      selectFilters["max"] !== ""
    ) {
      document.getElementById("activeDot").style.display = "flex";
    } else {
      document.getElementById("activeDot").style.display = "none";
    }
  }, [selectFilters]);

  return (
    <div className="parent-filter">
      <div className="active-filter" id="activeDot"></div>
      <Accordion defaultActiveKey={0}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Filters</Accordion.Header>
          <Accordion.Body>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <div className="div-width">
                    <div className="form-check">
                      <input
                        className="btn-check"
                        checked={quickFilter == "week" ? true : false}
                        type="radio"
                        name="shortingFilter"
                        id="Week"
                        autoComplete="off"
                        value="week"
                        onChange={(e) => {
                          setQuickFilter(e.target.value);
                        }}
                      />
                      <label htmlFor="Week" className="btn btn-outline-primary">
                        Week
                      </label>
                    </div>
                    <div className="form-check ">
                      <input
                        className="btn-check"
                        checked={quickFilter == "month" ? true : false}
                        type="radio"
                        name="shortingFilter"
                        id="Month"
                        autoComplete="off"
                        value="month"
                        onChange={(e) => {
                          setQuickFilter(e.target.value);
                        }}
                      />
                      <label
                        htmlFor="Month"
                        className="btn btn-outline-primary"
                      >
                        Month
                      </label>
                    </div>
                    <div className="form-check ">
                      <input
                        className="btn-check"
                        checked={quickFilter == "year" ? true : false}
                        type="radio"
                        name="shortingFilter"
                        id="Year"
                        autoComplete="off"
                        value="year"
                        onChange={(e) => setQuickFilter(e.target.value)}
                      />
                      <label htmlFor="Year" className="btn btn-outline-primary">
                        Year
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">Start Date</div>
                    <DatePicker
                      selected={selectFilters.startDate}
                      format="yyyy-MM-dd"
                      onChange={(date) => {
                        setSelectedFilters({
                          ...selectFilters,
                          startDate: date,
                        });
                        setQuickFilter("");
                      }}
                    />
                  </label>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">End Date</div>
                    <DatePicker
                      selected={selectFilters.endDate}
                      format="yyyy-MM-dd"
                      onChange={(date) => {
                        setSelectedFilters({
                          ...selectFilters,
                          endDate: date,
                        });
                        setQuickFilter("");
                      }}
                    />
                  </label>
                </div>
              </div>
              {!isTransaction ? (
                <div className="col-lg-4 col-md-6 ">
                  <div className="card-type">
                    <label className="labeling">
                      <div className="label-gap">Client</div>
                      <AsyncSelect
                        isMulti
                        isLoading={props.clientIsLoading}
                        value={selectedClients}
                        onChange={(data) => setSelectedClients(data)}
                        loadOptions={loadClientOptions}
                        defaultOptions={initialClientOptions}
                        placeholder={"Clients"}
                        styles={props.customStyle}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#5757fe",
                            primary: "#5757fe",
                          },
                        })}
                      />
                    </label>
                  </div>
                </div>
              ) : (<></>)}
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">Status</div>
                    <Select
                      value={selectFilters.status}
                      isMulti
                      onChange={(data) =>
                        setSelectedFilters({ ...selectFilters, status: data })
                      }
                      options={isTransaction ? transactionStatusOptions : statusOptions}
                      placeholder={"Status"}
                      styles={customStyle}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                    />
                  </label>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">Share Holder</div>
                    <Select
                      isMulti
                      value={selectFilters.shareHolders}
                      isLoading={props.shareHolderIsLoading}
                      options={shareHoldersOptions}
                      onChange={(data) =>
                        setSelectedFilters({
                          ...selectFilters,
                          shareHolders: data,
                        })
                      }
                      styles={customStyle}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                    />
                  </label>
                </div>
              </div>
              {!isTransaction ? (
                <div className="col-lg-4 col-md-6">
                  <div className="card-type">
                    <label className="labeling">
                      <div className="label-gap">Currency</div>
                      <Select
                        value={selectFilters.currency}
                        onChange={(data) =>
                          setSelectedFilters({
                            ...selectFilters,
                            currency: data,
                          }
                          )
                        }
                        options={options}
                        placeholder={"Currency"}
                        styles={customStyle}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#5757fe",
                            primary: "#5757fe",
                          },
                        })}
                      />
                    </label>
                  </div>
                </div>
              ) : (<></>)}
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">Min</div>
                    <div>
                      <input
                        className="input-css"
                        type="number"
                        value={selectFilters.min}
                        onChange={(event) => {
                          setSelectedFilters({
                            ...selectFilters,
                            min: event.target.value,
                          });
                        }}
                        placeholder="enter min value"
                      />
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <label className="labeling">
                    <div className="label-gap">Max</div>
                    <div>
                      <input
                        className="input-css"
                        type="number"
                        value={selectFilters.max}
                        onChange={(event) => {
                          setSelectedFilters({
                            ...selectFilters,
                            max: event.target.value,
                          });
                        }}
                        placeholder="enter max value"
                      />
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="card-type">
                  <div className="custom-btn-group">
                    <div className="apply-btn-div">
                      <button
                        className="apply-btn"
                        type="button"
                        onClick={(event) => handleApply(event)}
                      >
                        Apply
                      </button>
                    </div>
                    <div className="reset-btn-div">
                      <button
                        type="reset"
                        className="btn btn-outline-secondary"
                        onClick={(event) => handleReset(event)}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export const mapStateToProps = (state) => {
  return {
    clientList: state.clientsReducer.clients.rows,
    clientIsLoading: state.clientsReducer.loading,
    shareHolders: state.shareholdersReducer.shareholderslist,
    shareHolderIsLoading: state.shareholdersReducer.loading,
    currencylist: state.invoicesReducer.currencylist
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getClients: () => dispatch(getClients("")),
    getShareHoldersList: () => {
      dispatch(getShareholdersList());
    },
    getCurrencyList: getCurrencyList()
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Invoicefilter);
